import { Table, TableCell, withStyles } from '@material-ui/core'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import theme from 'styles/theme'

export const TableRowAlternada = withStyles(() => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.colors.mainBg
    }
  }
}))(TableRow)

export const TableContainerCustomizado = styled(TableContainer)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGray};
    border-radius: 8px;
    border-collapse: collapse;
  `}
`

export const TableRowBranca = styled(TableRow)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`
export const TableRowCinza = styled(TableRow)`
  ${({ theme }) => css`
    background-color: ${theme.colors.gray2};
  `}
`
export const TableRowVerde = styled(TableRow)`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary3};
  `}
`
export const TableRowVerdeClaro = styled(TableRow)`
  ${({ theme }) => css`
    background-color: ${theme.colors.lightGreen};
    color: ${theme.colors.primary} !important;
    text-align: center;
  `}
`

export const TableCellSubItem = styled(TableCell)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.lightGray};
    padding: 8px 8px 8px 24px !important;
    font-size: ${theme.font.sizes.xsmall} !important;
  `}
`

export const TableCellCustomizado = styled(TableCell)`
  ${({ theme }) => css`
    padding: 8px !important;
    font-size: ${theme.font.sizes.xsmall} !important;
  `}
`
export const TableCellCentralizado = styled(TableCellCustomizado)`
  text-align: center !important;
`
export const TableCellLabel = styled(TableCellCustomizado)`
  ${({ theme }) => css`
    width: 50%;
    border-right: 1px solid ${theme.colors.lightGray};
  `}
`
export const TableCellValor = styled(TableCellCustomizado)`
  text-align: right !important;
`
export const TableCellValorBorda = styled(TableCellCustomizado)`
  ${({ theme }) => css`
    text-align: right !important;
    border-right: 1px solid ${theme.colors.lightGray};
  `}
`

export const TableCellBold = styled(TableCellCustomizado)`
  ${({ theme }) => css`
    font-weight: ${theme.font.bold} !important;
  `}
`
export const TableCellBoldBorda = styled(TableCellCustomizado)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.lightGray};
    font-weight: ${theme.font.bold} !important;
  `}
`

export const TableCellBoldCentralizado = styled(TableCellBold)`
  text-align: center !important;
`
export const TableCellBoldBordaCentralizado = styled(TableCellBoldBorda)`
  text-align: center !important;
`

export const TableCellBorda = styled(TableCellCustomizado)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.lightGray};
  `}
`

export const TableCellBoldAlignRight = styled(TableCellBold)`
  text-align: right !important;
`

export const Wrapper = styled.div`
  width: 100%;
`
export const WrapperHideMobile = styled(Wrapper)`
  ${media.lessThan('small')`
  display: none
  `}
`

export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin: 40px 0px 24px 0px;
`

export const TableLayoutFixed = styled(Table)`
  table-layout: fixed;
`
